import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles, { scrollableTableContainer } from "component/utils/DatatableStyles";

const paginationOptions = {
  rowsPerPageText: "Show Per Page:",
  rangeSeparatorText: "dari",
};

const LovCoAFrom = ({ show, data, onClose, onSelect }) => {
  const [search, setSearch] = useState("");

  if (!show) return null;

  const formattedData = data.map((item, index) => ({
    id: index + 1,
    ...item,
  }));

  const filteredData = formattedData.filter((item) =>
    [
      item?.group_account_code,
      item?.group_account_desc,
      item?.group_account_div,
      item?.group_account_dep,
    ].some((field) =>
      field?.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  const columns = [
    {
      name: "No",
      selector: (row) => row.id,
      minWidth: "50px",
      center: true,
      sortable: true,
    },
    {
      name: "Kode",
      selector: (row) => row.group_account_code,
      sortable: true,
      center: true,
      minWidth: "80px",
    },
    {
      name: "Deskripsi",
      selector: (row) => row.group_account_desc,
      sortable: true,
      minWidth: "250px",
    },
    {
      name: "Div",
      selector: (row) => row.group_account_div,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Dep",
      selector: (row) => row.group_account_dep,
      sortable: true,
      minWidth: "200px",
    },
    {
      name: "Aksi",
      cell: (row) => (
        <button className="btn btn-sm btn-primary" onClick={() => onSelect(row)}>
          Pilih
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "70px",
    },
  ];

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Pilih Data</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-3 d-flex justify-content-start">
              <input
                type="text"
                className="form-control"
                placeholder="Cari data..."
                style={{ maxWidth: "250px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div style={scrollableTableContainer}>
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                customStyles={DatatableStyles}
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 25]}
                paginationComponentOptions={paginationOptions}
                responsive={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LovCoAFrom;
